/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import {
    LocationList, LocationEdit, LocationTemplateList, LocationTemplateEdit,
    StaffAgentsList, StaffAgentsEdit, LocationImages, LocationAdd
} from 'features/components/base/locations';
import { LocationTaxExemption } from 'features/components/base/locations/LocationTaxExemption';

/**
 * routing for location components
 * 
 * @param props
 * 
 * @return routing for location components
 * 
**/

export class LocationsRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/locations`} component={LocationList} />
                <Route exact path={`/locations/create`} component={LocationAdd} />
                <Route exact path={`/locations/edit/:locationId`} component={LocationEdit} />

                <Route exact path={`/locations/images`} component={LocationImages} />

                <Route exact path={`/locations/staff-agents`} component={StaffAgentsList} />
                <Route exact path={[`/locations/staff-agents/create`, `/locations/staff-agents/edit/:locationId/:staffAgentId`]} component={StaffAgentsEdit} />

                <Route exact path={`/locations/templates`} component={LocationTemplateList} />
                <Route exact path={`/locations/tax-exemption`} component={LocationTaxExemption} />
                <Route exact path={`/locations/templates/edit/:templateId`} component={LocationTemplateEdit} />
                
                <Redirect to="/home" />
            </Switch>
        );
    }
}
